import { colors } from '@/theme'
import { Box, Grid, Tooltip, Typography } from '@mui/material'

export function DetailField({
  label,
  value,
  size = 3
}: {
  label: string
  value?: string | number | null
  size?: number
}) {
  const isValueEmpty = value === null || value === undefined || value === ''

  return (
    <Grid size={size}>
      <Typography sx={{ color: colors.text.secondary, fontSize: '12px', mb: 0.5 }}>{label}</Typography>
      <Tooltip title={isValueEmpty ? '' : String(value)} disableHoverListener={isValueEmpty}>
        <Typography
          sx={{
            color: colors.text.dark,
            fontSize: '14px',
            fontWeight: 400,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {isValueEmpty ? '-' : value}
        </Typography>
      </Tooltip>
    </Grid>
  )
}

export function DetailFieldRow({ children }: { children: React.ReactNode }) {
  return (
    <Grid
      container
      sx={{
        '& > *:not(:last-of-type)': {
          borderRight: `1px solid ${colors.border.default}`,
          pr: 3
        },
        '& > *:not(:first-of-type)': { pl: 3 }
      }}
    >
      {children}
    </Grid>
  )
}

export function DetailFieldGroup({ children }: { children: React.ReactNode }) {
  return <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>{children}</Box>
}
